import { Box, Typography, useTheme } from "@mui/material";
import { shades } from "../../theme";

const Contact = () => {
  const theme = useTheme();

  return (
    <Box
      width="80%"
      margin="80px auto"
      display="flex"
      flexDirection="column"
      alignItems="center"
    >
      <Typography variant="h1" textAlign="center" marginBottom="40px">
        Contact Us
      </Typography>

      {/* Closure Notice */}
      <Box marginBottom="40px" textAlign="center" maxWidth="800px">
        <Typography
          variant="h5"
          marginBottom="20px"
          sx={{
            color: "#d32f2f",
            fontWeight: "bold"
          }}
        >
          Road Race 1 is Closed
        </Typography>
        <Typography variant="body1" marginBottom="20px" sx={{ lineHeight: 1.8 }}>
          As of December 14, 2025, Road Race 1 has ceased operations.
          We are no longer accepting orders or providing customer support.
        </Typography>
        <Typography variant="body1" marginBottom="30px" sx={{ lineHeight: 1.8 }}>
          For any questions or opportunities, please reach out via email.
          We will do our best to direct you to the right resources or answer questions during this transition.
        </Typography>
      </Box>

      {/* Contact Information */}
      <Box marginBottom="40px" textAlign="center">
        <Typography variant="h3" marginBottom="20px">
          Contact Information
        </Typography>
        <Typography variant="body1" marginBottom="10px">
          Email:{" "}
          <a
            href="mailto:shawn@roadrace1.com"
            style={{ color: shades.secondary[500], textDecoration: "none", fontWeight: "bold" }}
          >
            shawn@roadrace1.com
          </a>
        </Typography>
      </Box>
    </Box>
  );
};

export default Contact;
